<template>
  <transition name="fade">
    <div v-if="visible" class="confirm-dialog-mask" @click="handleCancel">
      <div class="confirm-dialog" @click.stop>
        <div class="confirm-dialog-body">
          <img v-if="confirmText" src="/static/404/wenhao.png" alt="" class="confirm-icon">
          <img v-else src="/static/404/gantan.png" alt="" class="confirm-icon">
          <p class="confirm-text">{{ message }}</p>
        </div>
        <div class="confirm-dialog-footer">
          <div v-if="cancelText" class="confirm-btn cancel-btn" @click="handleCancel">{{ cancelText }}</div>
          <div v-if="confirmText" class="confirm-btn delete-btn" @click="handleConfirm">{{ confirmText }}</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ConfirmDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: "是否删除产品？"
    },
    confirmText: {
      type: String,
      default: "删除"
    },
    cancelText: {
      type: String,
      default: "取消"
    }
  },
  methods: {
    handleCancel() {
      this.$emit("cancel");
    },
    handleConfirm() {
      this.$emit("confirm");
    }
  }
};
</script>

<style scoped>
.confirm-dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.confirm-dialog {
  width: 320px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.confirm-dialog-body {
  padding: 30px 20px 20px;
  text-align: center;
}

.confirm-icon {
  width: 49px;
  height: 49px;
  margin-bottom: 16px;
}

.confirm-text {
  font-size: 18px;
  color: #333;
  margin: 0;
}

.confirm-dialog-footer {
  display: flex;
  border-top: 1px solid #f0f0f0;
}

.confirm-btn {
  flex: 1;
  text-align: center;
  padding: 14px 0;
  font-size: 18px;
  cursor: pointer;
  color: #666;
}

.confirm-btn:hover {
  background: #f5f5f5;
}

.cancel-btn {
  border-right: 1px solid #f0f0f0;
}

.delete-btn {
  color: #333;
  font-weight: 500;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ConfirmDialog.vue